import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette from "./PMGColorPalette";
import {PanelBody,Panel,RangeControl,CheckboxControl,SelectControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck
} from '@wordpress/block-editor';

registerBlockType({
  "name":"template-scripts/section-header",
  "title":"Section Header",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    mainText:{type:'string'},
    subText:{type:'string'},
    textColor:{type:'string'},
    size:{type:'string',default:'normal'},
    textAlign:{type:'string',default:'left'},
  }
},{
  edit:function({attributes,setAttributes}){

    return (<>
      <InspectorControls>
        <Panel>

          <PanelBody title="Header Size">
            <SelectControl
              options={[
                {value:'small',label:'Small'},
                {value:'normal',label:'Normal'},
                {value:'large',label:'Large'},
                {value:'extralarge',label:'Extra Large'},
              ]}
              onChange={(v)=>setAttributes({size:v})}
              value={attributes.size}
            />
          </PanelBody>
        </Panel>    
        <Panel>
          <PanelBody title="Text Color">
            <PMGColorPalette
                value={attributes.textColor}
                onChange={(v)=>{ setAttributes({textColor:v}); }}
            />
          </PanelBody>
        </Panel>
      </InspectorControls>
      <BlockControls>
        <AlignmentToolbar
					value={ attributes.textAlign }
					onChange={ ( nextAlign ) => {
						setAttributes( { textAlign: nextAlign } );
					} }
				/>
      </BlockControls>
      <div {...useBlockProps({className:`sectionHeader ${attributes.size}`,style:{textAlign:attributes.textAlign}})}>

        <RichText tagName="h6" placeholder="SUBTEXT" value={attributes.subText} style={{textAlign:attributes.textAlign,color:attributes.textColor,borderBottomColor:attributes.textColor}} onChange={(v)=>setAttributes({subText:v})}/>
        <RichText tagName="h3" placeholder="Section Title" value={attributes.mainText} style={{textAlign:attributes.textAlign,color:attributes.textColor}}  onChange={(v)=>setAttributes({mainText:v})}/>
      </div>
    </>);
  },
  save:function({attributes}){
    return (<div className={`sectionHeader ${attributes.size}`} style={{textAlign:attributes.textAlign}}>
      <RichText.Content tagName="h6" style={{textAlign:attributes.textAlign,color:attributes.textColor,borderBottomColor:attributes.textColor}} value={attributes.subText}/>
      <RichText.Content tagName="h3" style={{textAlign:attributes.textAlign,color:attributes.textColor}} value={attributes.mainText}/>
    </div>);
  }
});
